<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>Customer Previous History</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div>
          <h2>Customer Information Above Receipt:</h2>
          <v-simple-table class="mt-10">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Reference Number</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Reason</th>
                  <th class="text-left">IBAN</th>
                  <th class="text-left">Mobile</th>
                  <th class="text-left">Email</th>
                </tr>
              </thead>
              <tbody>
                <td>{{ customerInfo.referenceNumber }}</td>
                <td>{{ customerInfo.status }}</td>
                <td>{{ customerInfo.rejectReason }}</td>
                <td>{{ customerInfo.iban }}</td>
                <td>{{ customerInfo.mobile }}</td>
                <td>{{ customerInfo.email }}</td>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <h2 class="mt-5">Previous Receipts:</h2>
        <div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Date/Time</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Reject Reason</th>
                  <th class="text-left">Reject Source</th>
                  <th class="text-left">Images</th>
                  <th class="text-left">Reference Number</th>
                  <th class="text-left">IBAN</th>
                  <th class="text-left">Mobile</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Registered</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in prevReceipts" v-bind:key="item.id">
                  <template v-if="item">
                    <td>{{ formatDate(item.receiptDateTime) }} {{formatTime(item.receiptDateTime)}}</td>
                    <td>{{ item.status === "Confirmed" ? "Conf" : "Rej" }}</td>
                    <td>{{ item.rejectReason }}</td>
                    <td>{{ item.querySource }}</td>
                    <td>
                      <a target="_blank" :href="item.receiptImageURL">Receipt</a>
                      <br />
                      <a v-if="item.productImageURL" target="_blank" :href="item.productImageURL">Product</a>
                    </td>
                    <td>{{ item.referenceNumber }}</td>
                    <td>{{ item.iban }}</td>
                    <td>{{ item.mobile }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.userRegistered === 1 ? "Y" : "N" }}</td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel v-if="selectedDashboard.hasMistakesReport">
      <v-expansion-panel-header>Dashboarders worked on this Receipt</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div>
          <v-simple-table dense class="all-dashboarders">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Dashboarder ID</th>
                  <th class="text-left">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in allDashboarders" v-bind:key="item.id"
                  :class="{ 'active': selectedDashboarder == item.id}"
                  @click="selectedDashboarder = item.id"
                  class="item"
                >
                  <template v-if="item">
                    <td>{{ item.id }}</td>
                    <td>{{ item.email }}</td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <v-form ref="mistakeForm" class="mt-5 d-flex align-center" style="column-gap: 20px;">
          <v-autocomplete
            prepend-icon="mdi-alert"
            v-model="mistake"
            :items="mistakeReasons"
            item-value="key"
            item-text="message"
            label="Mistake Reason"
            :required="true"
            :rules="[v => !!v || 'Please select a mistake reason']"
          ></v-autocomplete>
          <v-text-field
            v-if="allowExtraField"
            v-model="otherReason"
            outlined
            label="Comment"
            placeholder="Comment"
            hide-details
            class="mb-3"
            :rules="[v => !!v || 'Please enter a comment']"
            :required="true"
          ></v-text-field>
          <v-btn @click="_reportMistake" color="primary">Report Mistake</v-btn>
        </v-form>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <div style="width: 100%; padding-top: 10px">
      <v-expansion-panel v-if="this.used">
        <v-expansion-panel-header>Used Receipt Data</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date/Time</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Images</th>
                    <th class="text-left">Reference Number</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in usedReceipts" v-bind:key="item.id">
                    <template v-if="item">
                      <td>{{formatTime(item.receiptDateTime) }}</td>
                      <td>
                        {{ item.status === "Confirmed" ? "Conf" : "Rej" }}
                      </td>
                      <td>
                        <a target="_blank" :href="item.receiptImageURL">Receipt</a>
                        <br />
                        <a v-if="item.productImageUrl" target="_blank" :href="item.productImageURL">Product</a>
                      </td>
                      <td>{{ item.referenceNumber }}</td>
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <div style="width: 100%; padding-top: 10px">
      <v-expansion-panel v-if="hasParallelCampaign()">
        <v-expansion-panel-header
          >Parallel Campaign:
          {{ this.parallelCampaignId }}</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <div>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Reference Number</th>
                    <th class="text-left">Ean</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Items</th>
                    <th class="text-left">Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in parallelCampaignProducts"
                    v-bind:key="item.ean"
                  >
                    <template v-if="item">
                      <td>{{ item.referenceNumber }}</td>
                      <td>{{ item.ean }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.items }}</td>
                      <td>{{ item.total }}</td>
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-expansion-panels>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import axios from "axios";

export default {
  data: () => ({
    parallelCampaignId: '',
    parallelCampaignProducts: [],
    mistakeReasons: [],
    otherReason: '',
    mistake: '',
    allDashboarders: [],
    selectedDashboarder: null,
  }),
  async mounted () {
    // Get mistake reasons from BE
    try {
      const response = await this.getMistakeReasons({ userToken: this.userToken, dashboard: this.selectedDashboard });
      this.mistakeReasons = Object.keys(response).map(key => ({ key, message: response[key] }));
    } catch (error) {
      console.error(error);
      this.snackAlert({
        message: "Error fetching mistake reasons",
        type: "error"
      });
    }
    // Get all dashboarders who worked on this receipt
    try {
      this.allDashboarders = await this.getAllDashboarders({ userToken: this.userToken, campaignId: this.campaign_fk, referenceNumber: this.referenceNumber, dashboard: this.selectedDashboard });
    } catch (error) {
      console.error(error);
      this.snackAlert({
        message: "Error fetching all dashboarders",
        type: "error"
      });
    }
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard", "userRoles", "receiptImageFile"]),
    ...mapFields(["prevReceipts", "usedReceipts", "customerInfo", "used", "campaign_fk", "referenceNumber", 
      "receiptImageURL", "receiptDateTime", "retailerFk", "total", "receiptId", "country",
      "rejectReason", "location", "processedProducts"
    ]),
    allowExtraField () {
      return this.mistake == "NOT_VALID_RECEIPT_PICTURE_ACCEPTED" || this.mistake == "NOT_VALID_PRODUCT_PICTURE_ACCEPTED" || this.mistake == "OTHER";
    }
  },
  methods: {
    ...mapActions(["reportMistake", "getAllDashboarders", "snackAlert", "getMistakeReasons", "getSubmittedReports"]),
    hasParallelCampaign () {
        const campaignId = this.$store.state.currentReceipt.campaign_fk;
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[campaignId] &&
          this.selectedDashboard.campaigns[campaignId].hasParallelCampaign
        ) {
          this.getParallelProduct();
          return true;
        } else return false;
    },
    formatDate(val) {
      return moment(val).format("MM-DD");
    },
    formatDateLocal(val) {
      return moment(val).format("DD-MM-YYYY HH:mm");
    },
    formatTime(val) {
      return moment(val).format("HH:mm");
    },
    getParallelProduct() {
        const campaignId = this.$store.state.currentReceipt.campaign_fk;
        const customerToken = this.$store.state.currentReceipt.customerToken;
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[campaignId] &&
          this.selectedDashboard.campaigns[campaignId].hasParallelCampaign
        ) {
          const url = `${this.selectedDashboard.endPoints.base}${this.selectedDashboard.endPoints.getParallelCampaignProduct}`;
          const data = { sessid: this.userToken, campaignId, customerToken };
          axios({ method: "post", url, data })
            .then((response) => {
              if (response.data) {
                this.parallelCampaignProducts = response.data.parallelCampaignProducts;
                this.parallelCampaignId = response.data.parallelCampaignId;
              }
            })
            .catch((er) => {});
        }
    },
    async _reportMistake() {
      const valid = this.$refs.mistakeForm.validate();
      if (!this.selectedDashboarder) {
        return this.snackAlert({
          message: "Please select a dashboarder from the list",
          type: "error"
        });
      }
      if (valid) {
        const formData = new FormData();
        formData.append('file', this.receiptImageFile);
        formData.append('name', 'test/test/test');
        const resp = await axios.post('https://template-v2.justsnap.eu/api/template/uploadAsset', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        let imageLink = null;
        if (resp.data && resp.data.result == "OK") imageLink = resp.data.file;
        const receipt = {
          image: imageLink,
        }

        if (this.receiptDateTime) {
          receipt.date = this.receiptDateTime.split(" ")[0];
          receipt.time = this.receiptDateTime.split(" ")[1];
        }
        if (this.retailerFk) receipt.retailer = this.retailerFk;
        if (this.processedProducts) receipt.products = this.processedProducts;
        if (this.receiptId) receipt.receiptId = this.receiptId;
        if (this.country) receipt.country = this.country;
        if (this.total) receipt.total = this.total;
        if (this.location) receipt.location = this.location;
        if (this.rejectReason) receipt.rejectReason = this.rejectReason;
        
        try {
          await this.reportMistake({
            campaignId: this.campaign_fk,
            referenceNumber: this.referenceNumber,
            reason: this.mistake,
            description: this.otherReason,
            userToken: this.userToken,
            dashboard: this.selectedDashboard,
            dashboarderId: this.selectedDashboarder,
            receipt
          });
          this.$refs.mistakeForm.reset();

          return this.snackAlert({
            message: "Mistake reported successfully",
            type: "success"
          });
        } catch (error) {
          console.error(error);
          return this.snackAlert({
            message: "Error reporting mistake",
            type: "error"
          });
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .all-dashboarders .item {
    cursor: pointer;
    td {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .active {
      background-color: rgba(0,0,0,.87);
    }
  }
</style>